import { useReplyToTicket } from '@practium/features/api';
import { useToast } from '@practium/ui';
import { useState } from 'react';
import { useGetAdminSupportTickets } from '../../../../../../packages/features/api/hooks/support';

export const useAdminSupportPage = () => {
	const { success, error } = useToast();
	const { mutateAsync: replyToTicket } = useReplyToTicket();
	const [page, setPage] = useState(1);
	const [period, setPeriod] = useState('all');
	const [statusFilter, setStatusFilter] = useState('open');
	const [sortOrder, setSortOrder] = useState('recent');
	const [customDateFrom, setCustomDateFrom] = useState('');
	const [customDateTo, setCustomDateTo] = useState('');

	const {
		data: tickets,
		isLoading,
		pagination,
	} = useGetAdminSupportTickets({
		page,
		limit: 6,
		status: statusFilter,
		period,
		sortOrder,
		customDateFrom,
		customDateTo,
	});

	const handlePeriodChange = (value: string) => {
		setPeriod(value);
		setPage(1);
	};
	const handleStatusChange = (value: string) => {
		setStatusFilter(value);
		setPage(1);
	};
	const handleSortChange = (value: string) => {
		setSortOrder(value);
		setPage(1);
	};
	const handleDateRangeChange = (from: string, to: string) => {
		setCustomDateFrom(from);
		setCustomDateTo(to);
		setPage(1);
	};

	const handleReply = async (ticketId: string, message: string) => {
		try {
			await replyToTicket({ ticketId, message });
			success('Resposta enviada com sucesso!');
		} catch {
			error('Erro ao enviar resposta. Tente novamente.');
		}
	};

	return {
		tickets,
		totalDocs: pagination?.totalDocs ?? 0,
		totalPages: pagination?.totalPages ?? 1,
		page,
		setPage,
		isLoading,
		period,
		handlePeriodChange,
		customDateFrom,
		customDateTo,
		handleDateRangeChange,
		statusFilter,
		handleStatusChange,
		sortOrder,
		handleSortChange,
		handleReply,
	};
};
